import React from "react";
import "./Nesteddropdown.css"

export default class NestedDropdown extends React.Component {

  // shape = {
  //   id: Prop.Type.string.isRequired,
  //   message: Prop.Type.node.isRequired,
  //   link: Prop.Type.string,
  //   options:Prop.Type.arrayOf(
  //     Prop.Type.shape(NestedDropdown.shape)
  //   )
  // };

  // static propTypes = {
  //   openDirection: Prop.Type.enumOf(['left', 'right']),
  //   displayText: Prop.Type.node.isRequired,
  //   hasCaret: Prop.Type.bool,
  //   options: Prop.Type.arrayOf(
  //     Prop.Type.shape(NestedDropdown.shape).isRequired
  //   ).isRequired
  // };

  // static defaultProps = {
  //   hasCaret: true,
  //   openDirection: 'left'
  // };

  constructor(props) {
    super(props);

    this.state = {
      showDropdown: false,
      mouseOver1: false,
      selectedIds: []
    };
    this.mouseEvent = this.mouseEvent.bind(this);
  };

  mouseEvent() {
    if (this.state.showDropdown && !this.state.mouseOver1) {
      this.handleDropdownClose();
    }
  }


  componentDidMount() {
    document.addEventListener("mouseup", this.mouseEvent);
  }

  componentWillUnmount() {
    document.removeEventListener("mouseup", this.mouseEvent);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.options !== nextProps.options
      || this.state.showDropdown !== nextState.showDropdown
      || this.state.selectedIds !== nextState.selectedIds;
  }

  handleDropdownToggle() {
    let nextState = !this.state.showDropdown;

    this.setState({
      showDropdown: nextState,
      selectedIds: []
    });
  };

  handleDropdownClose() {
    this.setState({
      showDropdown: false,
      selectedIds: []
    });
  };

  handleSelectedId(selected, depthLevel) {
    return () => {
      const updatedArray = this.state.selectedIds.slice(0);

      updatedArray[depthLevel] = selected;

      this.setState({
        selectedIds: updatedArray
      });
    };
  };

  renderDisplay() {
    let hasCaret = this.props.hasCaret || true;
    const classes = [
        'dropdown__display', //eslint-disable-line quote-props
        hasCaret ? 'dropdown__display--with-caret' : ''
      ].join(" "),
      caret = (
        // <small className="text-muted">
        <i className="fa fa-caret-down fa-lg dropdown__display-caret" style={{fontSize: 14}}/>
        // </small>
        // <Icon
        //   classes={ ['dropdown__display-caret'] }
        //   glyph={ iconChevronDown }
        //   size={ 'small' }
        // />
      );

    return (
      <div className={classes}>
        {this.props.displayText}
        {hasCaret ? caret : null}
      </div>
    );
  }

  renderSubMenu(options, depthLevel = 0) {

    if (this.state.showDropdown !== true) {
      return null;
    }

    const classes = ['dropdown__options'];

    let openDirection = this.props.openDirection || "left";
    classes.push(`dropdown__options--${openDirection}-align`);

    const menuOptions = options.map(option => {
        const hasOptions = (option.options
            && option.options.length > 0
          ),
          display = (option.link
              ? <a href={option.link}>{option.display}</a>
              : <span onClick={() => this.props.onClick(option.id)}>
              {option.display}
                {hasOptions && (
                  <i className="fa fa-caret-right fa-lg dropdown__display-caret" style={{fontSize: 14}}/>
                )}
            </span>
          );

        let subMenu;

        // only render selected submenu and only if nested options exist
        if ((this.state.selectedIds[depthLevel] === option.id)
          && hasOptions
        ) {
          const newDepthLevel = depthLevel + 1;

          subMenu = this.renderSubMenu(option.options, newDepthLevel);
        }

        return (
          <li
            key={option.id}
            onMouseEnter={this.handleSelectedId(option.id, depthLevel)}
          >
            {display}
            {subMenu}
          </li>
        );
      }
    );

    return (
      <div className={classes.join(" ")}>
        <ul>
          {menuOptions}
        </ul>
      </div>
    );
  }

  render() {
    return (
      <div
        className='dropdown dropdown--nested'
        onClick={() => this.handleDropdownToggle()}
        onMouseOver={() => this.setState({mouseOver1: true})}
        onMouseLeave={() => this.setState({mouseOver1: false})}
      >
        {this.renderDisplay()}
        {this.renderSubMenu(this.props.options)}
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/containers/Leads/components/NestedDropdown.js